// removed by extract-text-webpack-plugin
module.exports = {"blue":"#00A8E8","green":"#99C24D","avatar":"src-components-Avatar----Avatar-module---avatar---3hTp9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/Avatar.module.css
// module id = 203
// module chunks = 35783957827783 114276838955818